import { LoanInventoryTableFields } from '../../HbtPortfolioLoansInventoryTable/types';
import { ErrorMessageInfo, LoansErrorHookProps } from '../types';

const errorsMapping = (
  data: LoanInventoryTableFields | ErrorMessageInfo,
  loans: LoansErrorHookProps[]
) => {
  const errorMessageInfo = typeof data === 'string' ? data : data?.errorMessageInfo;
  if (!errorMessageInfo || !loans) return;

  const codes = errorMessageInfo.split(',').map((code) => code.trim());

  const errorMap = loans.reduce(
    (acc, error) => {
      acc[error.errorMessageDescriptionID] = error;
      return acc;
    },
    {} as Record<string, LoansErrorHookProps>
  );

  const mappedResult = codes.reduce(
    (acc, fullCode) => {
      const id = fullCode.split(':')[1];
      if (!id) return acc;

      const error = errorMap[id];

      if (error) {
        acc[fullCode] = error;
      } else {
        console.warn(`No matching error found for ID: ${id}`);
      }

      return acc;
    },
    {} as Record<string, LoansErrorHookProps>
  );

  return mappedResult;
};
export default errorsMapping;
